// src/components/NosotrosDetalle.js
import React from "react";

import "../layouts/NosotrosDetalle.css";
import title1b from "../assets/pc/hacemos/eventos.png";
import text1b from "../assets/pc/hacemos/textoeventos.png";
import title2b from "../assets/pc/hacemos/disenio.png";
import text2b from "../assets/pc/hacemos/textodisenio.png";
import title3b from "../assets/pc/hacemos/campanias.png";
import text3b from "../assets/pc/hacemos/textocampanias.png";
import title4b from "../assets/pc/hacemos/tecnologia.png";
import text4b from "../assets/pc/hacemos/textotecnologia.png";

import title1m from "../assets/celu/hacemos/tit_1.png";
import text1m from "../assets/celu/hacemos/text_1.png";
import title2m from "../assets/celu/hacemos/tit_2.png";
import text2m from "../assets/celu/hacemos/text_2.png";
import title3m from "../assets/celu/hacemos/tit_3.png";
import text3m from "../assets/celu/hacemos/text_3.png";
import title4m from "../assets/celu/hacemos/tit_4.png";
import text4m from "../assets/celu/hacemos/text_4.png";

import titleHacemos from  "../assets/pc/hacemos/titulo2.png";

const isMobile = window.innerWidth < 768;

let title1 = title1b;
let title2 = title2b
let title3 = title3b;
let title4 = title4b;

let text1 = text1b;
let text2 = text2b;
let text3 = text3b;
let text4 = text4b

if (isMobile) {
	title1 = title1m;
	title2 = title2m;
	title3 = title3m;
	title4 = title4m;
	text1 = text1m;
	text2 = text2m;
	text3 = text3m;
	text4 = text4m
}
function NosotrosDetalle() {
  return (
    <section className="nosotros-section" id="section3">
      <img
          className="nosotros-text"
          src={titleHacemos}
          alt="Detalle eventos"
          style={{
			  marginBottom: isMobile ? "40px" : "5%",
			  marginTop:isMobile ? '40%':'5%',
            width: isMobile ? "60%" : "30%",
          }}
        />

      <div className="nosotros-body" style={{ width: "100%" }}>
        <img
          className="nosotros-title"
          src={title1}
          alt="Eventos"
          style={{ marginBottom: "20px", width: isMobile ? "100%" : "70%" }}
        />
        <img
          className="nosotros-text"
          src={text1}
          alt="Detalle eventos"
          style={{
            marginBottom: isMobile ? "10px" : "20px",
            width: isMobile ? "100%" : "60%",
          }}
        />

        <img
          className="nosotros-title"
          src={title2}
          alt="Diseño"
          style={{
            marginTop: "30px",
            marginBottom: isMobile ? "10px" : "40px",
            width: isMobile ? "100%" : "65%",
          }}
        />
        <img
          className="nosotros-text"
          src={text2}
          alt="Detalle diseño"
          style={{
            marginBottom: isMobile ? "10px" : "40px",
            width: isMobile ? "100%" : "60%",
          }}
        />
        <img
          className="nosotros-title"
          src={title3}
          alt="Campania"
          style={{
            marginTop: "1px",
            marginBottom: isMobile ? "10px" : "10px",
            width: isMobile ? "100%" : "72%",
          }}
        />
        <img
          className="nosotros-text"
          src={text3}
          alt="Detalle diseño"
          style={{
            marginBottom: isMobile ? "10px" : "70px",
            marginTop: "-20px",
            width: isMobile ? "100%" : "60%",
          }}
        />
        <img
          className="nosotros-title"
          src={title4}
          alt="Tecno"
          style={{
            marginTop: "-20px",
            marginBottom: isMobile ? "10px" : "40px",
            width: isMobile ? "100%" : "65%",
          }}
        />
        <img
          className="nosotros-text"
          src={text4}
          alt="Detalle diseño"
          style={{ width: isMobile ? "100%" : "60%" }}
        />
      </div>
    </section>
  );
}

export default NosotrosDetalle;
